module.exports = __webpack_public_path__ + "static/media/Facebook.b64ec942.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Facebook.svg
// module id = 199
// module chunks = 0